/* AURA Welcome offer V5.1 (oct. 2026)
   Popup newsletter non modale ancrée au bas du viewport.
   Conserve la logique V4 : délai, déclenchement à l'engagement, attente de la décision cookies,
   mémorisation (mêmes clés de stockage qu'en V4), écran de succès.
   V5 : dialog.show() (pas de blocage de page), Échap géré, erreurs d'inscription réaffichées,
   suivi du clavier mobile via visualViewport.
   V5.1 (21/10/2026) : chaque formulaire newsletter (popup, footer) garde son propre état de
   succès ou d'erreur ; après un envoi depuis la popup, la page reste à la position du visiteur
   (plus de saut vers l'ancre du formulaire). */
(function(){
  'use strict';

  var qs=function(s,c){return (c||document).querySelector(s)};
  var qsa=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};

  function local(){try{return window.localStorage}catch(e){return null}}
  function get(key){try{var s=local();return s&&s.getItem(key)}catch(e){return null}}
  function set(key,value){try{var s=local();if(s)s.setItem(key,String(value))}catch(e){}}
  function sget(key){try{return window.sessionStorage&&window.sessionStorage.getItem(key)}catch(e){return null}}
  function sset(key,value){try{if(window.sessionStorage)window.sessionStorage.setItem(key,String(value))}catch(e){}}
  function sdel(key){try{if(window.sessionStorage)window.sessionStorage.removeItem(key)}catch(e){}}

  function emit(name,detail){
    try{document.dispatchEvent(new CustomEvent(name,{detail:detail||{}}))}catch(e){}
  }

  function isDisplayed(el){
    if(!el||el.hidden||el.closest('[hidden]')||el.getAttribute('aria-hidden')==='true')return false;
    var cs=window.getComputedStyle(el);
    if(cs.display==='none'||cs.visibility==='hidden'||Number(cs.opacity)===0)return false;
    var r=el.getBoundingClientRect();
    return r.width>0&&r.height>0;
  }

  /* V5.1 : identification du formulaire réellement envoyé. */
  var ORIGIN='aura:nl:origin';
  var SCROLL='aura:nl:scroll';

  function customerForms(){
    return qsa('form').filter(function(f){
      var t=f.querySelector('input[name="form_type"]');
      return !!(t&&t.value==='customer');
    });
  }

  function isPopupForm(form){return !!(form&&form.querySelector('[data-aura-newsletter]'))}

  /* Marqueur de session posé à l'envoi ; à défaut, ancre de retour ajoutée par Shopify (#id du formulaire). */
  function readOrigin(){
    var origin=sget(ORIGIN)||'';
    sdel(ORIGIN);
    if(!origin){
      var h=(location.hash||'').slice(1);
      try{h=decodeURIComponent(h)}catch(e){}
      var el=h?document.getElementById(h):null;
      if(el&&el.tagName==='FORM')origin=h;
    }
    return origin;
  }

  /* Shopify affiche le résultat du dernier envoi dans tous les formulaires "customer" de la page :
     on retire cet état des formulaires qui n'ont pas été envoyés. */
  function resetFormState(form){
    var selector=isPopupForm(form)?'.aura-nl__errors':'.aura-footer__form-message,.errors,[role="alert"],[role="status"]';
    qsa(selector,form).forEach(function(el){if(el.parentNode)el.parentNode.removeChild(el)});
    qsa('input[type="email"],input[name="contact[first_name]"]',form).forEach(function(input){
      input.value='';
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    });
  }

  /* Retire l'ancre et les paramètres d'envoi de l'URL, sans recharger la page. */
  function cleanUrl(){
    try{
      var u=new URL(window.location.href);
      var keys=[];
      u.searchParams.forEach(function(v,k){
        if(k==='customer_posted'||k==='form_type'||k==='utf8'||/^contact\[/.test(k))keys.push(k);
      });
      keys.forEach(function(k){u.searchParams.delete(k)});
      var q=u.searchParams.toString();
      window.history.replaceState(window.history.state,'',u.pathname+(q?'?'+q:''));
    }catch(e){}
  }

  /* Ramène la page à la position du visiteur avant l'envoi, tant qu'il n'a pas lui-même fait défiler. */
  function holdScroll(y){
    if(!(y>=0))return;
    var cancelled=false;
    var cancel=function(){cancelled=true};
    ['wheel','touchstart','keydown','pointerdown'].forEach(function(n){
      window.addEventListener(n,cancel,{once:true,passive:true});
    });
    var apply=function(){if(!cancelled)window.scrollTo(0,y)};
    apply();
    if(window.requestAnimationFrame)window.requestAnimationFrame(apply);
    if(document.readyState!=='complete'){
      window.addEventListener('load',function(){apply();window.setTimeout(apply,150)},{once:true});
    }else{
      window.setTimeout(apply,150);
    }
  }

  function init(dialog,origin){
    if(dialog._auraNl)return;
    dialog._auraNl=true;
    if(typeof dialog.show!=='function')return;

    /* Mêmes clés qu'en V4 : un visiteur déjà inscrit ou ayant fermé la popup reste respecté. */
    var DISMISSED='aura:welcome:dismissed';
    var CLAIMED='aura:welcome:claimed';
    var SEEN='aura:welcome:session-seen';
    var SUBMITTED='aura:welcome:submitted';

    var success=dialog.dataset.success==='true';
    var hasErrors=dialog.dataset.errors==='true';
    var delay=Math.max(5,Number(dialog.dataset.delay||8))*1000;
    var days=Math.max(1,Number(dialog.dataset.dismissDays||4));

    var armed=false;
    var opened=false;
    var interacted=false;
    var retryTimer=0;

    function uiIsBusy(){
      var a=document.activeElement;
      if(a&&!dialog.contains(a)&&/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName))return true;
      if(document.body.classList.contains('is-locked'))return true;
      if(qs('dialog[open]:not([data-aura-newsletter])'))return true;
      if(qsa('[aria-modal="true"]:not(.aura-nl)').some(isDisplayed))return true;
      if(qsa('header [aria-controls][aria-expanded="true"]').some(function(b){return isDisplayed(document.getElementById(b.getAttribute('aria-controls')))}))return true;
      return false;
    }

    function canOpen(){
      if(opened||dialog.open)return false;
      if(qs('[data-aura-cookie]:not([hidden])'))return false;
      if(get(CLAIMED))return false;
      if(uiIsBusy())return false;
      var until=Number(get(DISMISSED)||0);
      if(until&&until>Date.now())return false;
      if(sget(SEEN))return false;
      return true;
    }

    /* Clavier mobile : garde la popup au-dessus du clavier virtuel. */
    var vv=window.visualViewport;
    function syncKeyboard(){
      if(!vv||!dialog.open)return;
      var gap=Math.max(0,Math.round(window.innerHeight-(vv.height+vv.offsetTop)));
      dialog.style.setProperty('--aura-nl-kb',(gap>60?gap:0)+'px');
    }
    function watchKeyboard(on){
      if(!vv)return;
      var m=on?'addEventListener':'removeEventListener';
      vv[m]('resize',syncKeyboard);
      vv[m]('scroll',syncKeyboard);
      if(!on)dialog.style.removeProperty('--aura-nl-kb');
    }

    function onKeydown(e){
      if(e.key!=='Escape'||!dialog.open)return;
      /* Échap ferme la popup si le focus y est, ou si aucun autre panneau n'est ouvert. */
      if(dialog.contains(document.activeElement)||!uiIsBusy()){
        e.preventDefault();
        close(!success,'escape');
      }
    }

    function open(force,focusTarget){
      if(!force&&!canOpen())return false;
      if(dialog.open)return true;

      opened=true;
      sset(SEEN,'1');

      var previous=document.activeElement;
      try{dialog.show()}catch(e){dialog.setAttribute('open','')}

      if(focusTarget){
        /* Ouverture suite à une action du visiteur (succès ou erreur) : focus dans la popup. */
        try{focusTarget.focus({preventScroll:true})}catch(e){}
      }else{
        /* Ouverture automatique : ne pas voler le focus de la page. */
        if(dialog.contains(document.activeElement)){
          try{document.activeElement.blur()}catch(e){}
          if(previous&&previous!==document.body&&document.contains(previous)){
            try{previous.focus({preventScroll:true})}catch(e){}
          }
        }
      }

      document.addEventListener('keydown',onKeydown);
      watchKeyboard(true);
      syncKeyboard();
      emit('aura:promo:view',{success:success,errors:hasErrors});
      return true;
    }

    function close(markDismiss,reason){
      var hadFocus=dialog.contains(document.activeElement);
      if(dialog.open){
        try{dialog.close()}catch(e){dialog.removeAttribute('open')}
      }
      document.removeEventListener('keydown',onKeydown);
      watchKeyboard(false);
      if(markDismiss)set(DISMISSED,Date.now()+days*86400000);
      if(hadFocus){
        var main=document.getElementById('MainContent');
        if(main){try{main.focus({preventScroll:true})}catch(e){}}
      }
      emit('aura:promo:close',{reason:reason||'close',success:success});
    }

    function enoughScroll(){
      var threshold=window.innerWidth<900?180:120;
      return (window.scrollY||window.pageYOffset||0)>threshold;
    }

    function tryOpen(force){
      if(!armed||opened)return;
      if(force||interacted||enoughScroll()){
        if(!open(false))scheduleRetry();
      }
    }

    function scheduleRetry(){
      if(retryTimer||opened)return;
      retryTimer=window.setTimeout(function(){
        retryTimer=0;
        if(armed&&!opened)tryOpen(true);
      },1500);
    }

    var form=dialog.closest('form');

    /* V5.1 : l'origine connue (marqueur ou ancre) prime ; sinon, ancien marqueur de la V5. */
    var stored=!!sget(SUBMITTED);
    sdel(SUBMITTED);
    var fromPopup=origin?(!!form&&origin===form.id):stored;

    /* Erreur venant d'un autre formulaire : la popup garde un état vierge. */
    if(hasErrors&&!fromPopup){
      hasErrors=false;
      dialog.dataset.errors='false';
    }

    if(success){
      set(CLAIMED,'1');
      /* Seul un envoi fait depuis la popup rouvre l'écran de succès. */
      if(fromPopup){
        window.setTimeout(function(){open(true,qs('.aura-nl__title',dialog))},80);
      }
    }else if(hasErrors&&fromPopup){
      /* L'envoi a échoué : on rouvre la popup pour afficher l'erreur. */
      window.setTimeout(function(){
        open(true,qs('input[aria-invalid="true"]',dialog)||qs('input[name="contact[email]"]',dialog));
      },80);
    }else if(!get(CLAIMED)){
      window.setTimeout(function(){armed=true;tryOpen(false)},delay);
      /* Ne jamais bloquer l'offre si le visiteur n'interagit pas. */
      window.setTimeout(function(){if(armed&&!opened)tryOpen(true)},delay+5000);

      var onScroll=function(){
        interacted=true;
        tryOpen(false);
        if(opened)window.removeEventListener('scroll',onScroll);
      };
      window.addEventListener('scroll',onScroll,{passive:true});
      document.addEventListener('pointerdown',function(){interacted=true;tryOpen(false)},{once:true,passive:true});
      document.addEventListener('keydown',function(){interacted=true;tryOpen(false)},{once:true});
      document.addEventListener('aura:cookie:resolved',function(){
        if(armed&&!opened)window.setTimeout(function(){tryOpen(true)},450);
      },{once:true});
    }

    qsa('[data-aura-newsletter-close]',dialog).forEach(function(btn){
      btn.addEventListener('click',function(){close(!success,'button')});
    });

    if(form){
      form.addEventListener('submit',function(){
        sset(SUBMITTED,'1');
        emit('aura:promo:submit',{});
      });
    }
  }

  function boot(){
    var origin=readOrigin();
    var scrollY=Number(sget(SCROLL));
    sdel(SCROLL);
    var forms=customerForms();

    /* Marqueur posé à chaque envoi réel (la validation du navigateur bloque l'événement si le champ est invalide). */
    forms.forEach(function(f){
      f.addEventListener('submit',function(){
        sset(ORIGIN,f.id||'');
        if(isPopupForm(f))sset(SCROLL,Math.round(window.scrollY||window.pageYOffset||0));
      });
    });

    if(origin){
      forms.forEach(function(f){if(f.id!==origin)resetFormState(f)});
      var posted=document.getElementById(origin);
      if(isPopupForm(posted)){
        cleanUrl();
        holdScroll(scrollY);
      }
    }

    qsa('[data-aura-newsletter]').forEach(function(d){init(d,origin)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();